// @flow
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import type { State } from 'types/redux';

// Components
import CTAFlowHeader from './CTAFlowHeader';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { gtmUserEventShoppingCart } from 'store/reducers/gtm/actions';

// Selectors
import {
  getTotalPrice,
  getServicesCount,
  getServices,
  getDeclinedServices
} from 'store/reducers/appointment/selectors';
import {
  getPriceVisibility,
  getFlexPayConfiguration
} from 'store/reducers/dealerSettings/selectors';
import { hasPromotion } from 'store/reducers/promotions/selectors';
import { getTopCTA } from 'store/reducers/optimizelyABTest/selectors';
import { isLoggedIn } from 'store/reducers/user/selectors';
import { getProperty } from 'store/reducers/user/personInfo/selectors';

const mapStateToProps = (state: State) => ({
  services: getServices(state).concat(getDeclinedServices(state)),
  servicesCount: getServicesCount(state),
  totalPrice: getTotalPrice(state),
  showPrice: getPriceVisibility(state)(),
  hasPromotion: hasPromotion(state),
  isFlexPayEnabled: getFlexPayConfiguration(state),
  topCTA: getTopCTA(state),
  isLoggedIn: isLoggedIn(state),
  firstName: getProperty(state, 'firstName'),
  lastName: getProperty(state, 'lastName')
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ goTo, gtmUserEventShoppingCart }, dispatch);

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true }
  )
)(CTAFlowHeader);



// WEBPACK FOOTER //
// ./src/components/molecules/CTAFlowHeader/CTAFlowHeaderContainer.js